import { Button, LabeledValue } from "@adobe/react-spectrum";
import "./style.css";
import { USER_GUIDE_LINK } from "../../constants/constants";
import { appLogger } from "../../utils/logger";
import { EnvelopeIcon } from "../common/Icons";

const HelpSupport = () => {
  const getCircularReplacer = () => {
    const seen = new WeakSet();
    return (_: any, value: any) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return "[Circular]";
        }
        seen.add(value);
      }
      return value;
    };
  };

  const handleDownloadLogs = () => {
    try {
      const logsData = appLogger.getLogsForDownload();

      const jsonSafeData = JSON.stringify(logsData, getCircularReplacer(), 2);

      const blob = new Blob([jsonSafeData], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `aic-logs-${new Date().toISOString().split("T")[0]}.json`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
      console.log("Logs downloaded successfully");
    } catch (error) {
      console.error("Error downloading logs:", error);
    }
  };

  return (
    <div className="help-support-container">
      <div className="help-support-content">
        {/* Header with Guide title and Download logs button */}
        <div className="help-support-header">
          <h1 className="guide-title">Guide</h1>
          <Button 
            variant="cta" 
            onPress={handleDownloadLogs}
            UNSAFE_className="download-logs-button"
          >
            Download logs
          </Button>
        </div>

        {/* User Guide Link */}
        <div className="user-guide-section">
          <a 
            href={USER_GUIDE_LINK} 
            target="_blank" 
            rel="noopener noreferrer"
            className="user-guide-link"
          >
            Click here to access the complete iHub Production User Guide.
          </a>
        </div>

        {/* Contact Information */}
        <div className="contact-section">
          <div className="contact-header">
            <EnvelopeIcon color="#666666" />
          </div>
          <LabeledValue label="ContactEmail" value="dxoc-l3@adobe.com" />
        </div>
      </div>
    </div>
  );
};

export default HelpSupport;
